import { useEffect, useRef } from 'react'

const useScrollShadow = (dependencies = [], selector = null) => {
  const scrollableRef = useRef(null)

  useEffect(() => {
    let handleScrollShadow = null
    let element = null

    const setup = (el) => {
      if (!el) return
      element = el
      scrollableRef.current = el

      handleScrollShadow = () => {
        const { scrollTop, scrollHeight, clientHeight } = el
        const isScrollable = scrollHeight > clientHeight
        
        if (!isScrollable) {
          el.classList.remove('has-footer-shadow', 'has-header-shadow')
          return
        }

        const atTop = scrollTop <= 1
        const atBottom = Math.abs(scrollTop + clientHeight - scrollHeight) <= 2

        if (atTop) {
          el.classList.add('has-footer-shadow')
          el.classList.remove('has-header-shadow')
        } else if (atBottom) {
          el.classList.add('has-header-shadow')
          el.classList.remove('has-footer-shadow')
        } else {
          el.classList.add('has-header-shadow', 'has-footer-shadow')
        }
      }

      handleScrollShadow()
      el.addEventListener('scroll', handleScrollShadow)
    }

    if (selector) {
      const timer = setTimeout(() => setup(document.querySelector(selector)), 100)
      return () => {
        clearTimeout(timer)
        if (element && handleScrollShadow) element.removeEventListener('scroll', handleScrollShadow)
      }
    }

    setup(scrollableRef.current)
    return () => {
      if (element && handleScrollShadow) element.removeEventListener('scroll', handleScrollShadow)
    }
  }, [selector, ...dependencies])

  return scrollableRef
}

export default useScrollShadow

